"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingTransactionSchemaProperties = exports.BillingTransactionSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const BillingTransactionFulfillment = zod_1.z.enum([
    "scheduled",
    "rescheduled",
    "canceled",
    "completed",
    "no-show",
    "deleted",
    "non-billable",
]);
const BillingTransactionArtifactKind = zod_1.z.enum([
    "appointment",
    "billableRequest",
    "groupAppointment",
]);
const BillingTransactionUsageRate = zod_1.z.object({
    value: zod_1.z.number(),
    currency: zod_1.z.string(),
    taxTypeId: zod_1.z.string(),
});
exports.BillingTransactionSchema = base_schema_1.BaseSchema.extend({
    date: zod_1.z.date().optional(),
    fulfilledActivityDate: zod_1.z.date().optional(),
    paidAt: zod_1.z.date().optional().nullable(),
    memberId: zod_1.z.string(),
    clientId: zod_1.z.string().optional(),
    clientParentId: zod_1.z.string().optional().nullable(),
    artifact: zod_1.z.object({
        id: zod_1.z.string(),
        kind: BillingTransactionArtifactKind,
        title: zod_1.z.string().optional(),
        packageInstanceId: zod_1.z.string().optional().nullable(),
        outcomeId: zod_1.z.string().optional().nullable(),
        hoursConsumed: zod_1.z.number().optional(),
    }),
    // cost for the transaction per hour
    rate: zod_1.z.object({
        id: zod_1.z.string(),
        value: zod_1.z.number(),
    }),
    // amount (computed cost) = rate.value * duration
    amount: zod_1.z.number().optional(),
    // price for the transaction per hour
    usageRate: BillingTransactionUsageRate.optional(),
    // amount (computed price) = usageRate.value * duration
    usageAmount: zod_1.z.number().optional(),
    fulfillment: BillingTransactionFulfillment,
    invoiceId: zod_1.z.string().optional().nullable(),
    manualEntry: zod_1.z.boolean().optional().nullable(),
    rolloverHistory: zod_1.z
        .object({
        invoiceId: zod_1.z.string(),
        at: zod_1.z.date(),
    })
        .array()
        .optional(),
    accountsPayableInvoiceId: zod_1.z.string().optional().nullable(),
});
exports.BillingTransactionSchemaProperties = {
    collectionName: "billingTransactions",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=billing-transaction-schema.js.map